import axios from 'axios';
import Cookies from 'universal-cookie';
import { URL, getAuthorizationHeader, getAuthorizationHeaderUpload } from '../../constans/constants';
import { logout } from '../login/SesionService';

const cookies = new Cookies();
const getEmpresaId = () => cookies.get('empresa');

const handle401 = (error) => {
  if (error?.response?.status === 401) logout();
  return Promise.reject(error);
};

export const getColaboradores = (page = 0, pageSize = 10, search = '') => {
  const empresaId = getEmpresaId();
  const params = `?page=${page}&size=${pageSize}&search=${encodeURIComponent(search)}`;
  return axios.get(`${URL}vacaciones/empresa/${empresaId}/colaboradores${params}`, getAuthorizationHeader())
    .catch(handle401);
};

export const getVacaciones = (page = 0, pageSize = 10, search = '') => {
  const empresaId = getEmpresaId();
  const params = `?page=${page}&size=${pageSize}&search=${encodeURIComponent(search)}`;
  return axios.get(`${URL}vacaciones/empresa/${empresaId}/listar${params}`, getAuthorizationHeader())
    .catch(handle401);
};

export const getHistorial = (legajoId) =>
  axios.get(`${URL}vacaciones/legajo/${legajoId}/historial`, getAuthorizationHeader())
    .catch(handle401);

export const getSaldo = (legajoId) =>
  axios.get(`${URL}vacaciones/legajo/${legajoId}/saldo`, getAuthorizationHeader())
    .catch(handle401);

export const getSaldoByUsername = (username) =>
  axios.get(`${URL}vacaciones/usuario/${username}/saldo`, getAuthorizationHeader())
    .catch(handle401);

export const getLegajoIdByUsername = (username) =>
  axios.get(`${URL}vacaciones/usuario/${username}/legajo-id`, getAuthorizationHeader())
    .catch(handle401);

export const asignarVacaciones = (legajoId, datos) => {
  const empresaId = getEmpresaId();
  return axios.post(`${URL}vacaciones/legajo/${legajoId}/empresa/${empresaId}/asignar`, datos, getAuthorizationHeader())
    .catch(handle401);
};

export const modificarVacaciones = (id, datos) => {
  const empresaId = getEmpresaId();
  return axios.put(`${URL}vacaciones/${id}/empresa/${empresaId}/modificar`, datos, getAuthorizationHeader())
    .catch(handle401);
};

export const cancelarVacaciones = (id, datos) => {
  const empresaId = getEmpresaId();
  return axios.post(`${URL}vacaciones/${id}/empresa/${empresaId}/cancelar`, datos, getAuthorizationHeader())
    .catch(handle401);
};

export const importarCsv = (archivo) => {
  const empresaId = getEmpresaId();
  const formData = new FormData();
  formData.append('archivo', archivo);
  return axios.post(`${URL}vacaciones/empresa/${empresaId}/importar-csv`, formData, getAuthorizationHeaderUpload())
    .catch(handle401);
};

export const descargarPlantilla = () => {
  window.location.href = `${URL}vacaciones/plantilla-csv`;
};
